import React, { useState } from "react"
import { Layout } from '@components/Layout.jsx'
import { Link } from "gatsby"
import { Helmet } from 'react-helmet'
import { ArrowSquareOut, X } from "@phosphor-icons/react"
import SoftButton from "@components/common/SoftButton"
import LinkButton from "@components/common/LinkButton"
import SwimSection from "@components/Products/SizeAndFitnessGuide/SwimSection"
import MensApparel from "@components/Products/SizeAndFitnessGuide/MensApparel"
import WomensApparel from "@components/Products/SizeAndFitnessGuide/WomensApparel"
import SuitYourselfSection from "@components/Home/SuitYourself/SuitYourselfSection"

const BlackboughSizeGuide = ({hideHeader = false}) => {
    const [activeCategory, setActiveCategory] = useState('swim')

	return (
        <Layout gaEvent={{
			eventName: 'page_view', 
			params: {
				page_path: '/blackbough-size-guide',
				page_title: 'Blackbough Swim Size Guide - Blackbough Swim',
				queryName: 'blackbough size guide page',
			},
		}}>
            <Helmet>
                <title>Blackbough Swim Size Guide - Blackbough Swim</title>
                <meta name="description" content={`Blackbough Swim Size Guide. We understand how important it is to find the perfect swimsuit size for both confidence and comfort. Designed to complement a variety of body types, our swimwear offers options for every preference—whether you’re after full coverage or a daring cheeky fit, we have something just for you.`} />
            </Helmet>

            <section className="relative max-container p-8 md:p-16 xl:p-20 space-y-6">
                {!hideHeader && (
					<div className='w-full pb-8'>
						<div className='text-center space-y-1'>
							<h1 className='text-5xl'>Blackbough Sizing and Fit Guide</h1>
							<p className="text-md text-[#4F4F4F] max-w-[960px] mx-auto">
								We understand how important it is to find the perfect swimsuit size for both confidence and comfort. 
								Designed to complement a variety of body types, our swimwear offers options for every preference—whether 
								you’re after full coverage or a daring cheeky fit, we have something just for you.
							</p>
						</div>
					</div>
				)}

                <div className="flex flex-nowrap gap-4 p-2 justify-center">
                    <SoftButton
						label={"Swim"}
						className={`px-4 py-2 rings-on-hover text-sm md:text-lg w-auto my-2 justify-center ${
							activeCategory === "swim" && "rings-on-active ring-[#5D5D5D]"
						}`}
						defaultSelected={true}
						onClick={() => setActiveCategory("swim")}
						ariaLabel={`Size Guide Swim`}
                    />
                    <SoftButton
						label={"Women's Apparel"}
						className={`px-4 py-2 rings-on-hover text-sm md:text-lg w-auto my-2 justify-center ${
							activeCategory === "women" && "rings-on-active ring-[#5D5D5D]"
						}`}
						onClick={() => setActiveCategory("women")}
						ariaLabel={`Size Guide Women Apparel`}
                    />
                    <SoftButton
						label={"Men's Apparel"}
						className={`px-4 py-2 rings-on-hover text-sm md:text-lg w-auto my-2 justify-center ${
							activeCategory === "men" && "rings-on-active ring-[#5D5D5D]"
						}`}
						onClick={() => setActiveCategory("men")}
						ariaLabel={`Size Guide Men Apparel`}
                    />
                </div>

				<div className={`w-full flex flex-col xl:flex-row justify-between gap-8 text-md text-[#4F4F4F]`}>
					<div className="flex-1">
						<p>
							The right fit is key to feeling confident. Use our size guide to find your perfect match. 
							Some styles may run smaller or larger—check individual product descriptions. 
							If you’re between sizes, we suggest sizing up.
						</p>
					</div>

					<div className="flex-1 space-y-2">
						<p className="text-lg text-[#3D3D3D] font-semibold">STYLE GUIDE</p>
						<div>
							<span>Discover our</span> 
							<LinkButton 
								className={'inline mx-1.5 text-black'}
								label={'Bikini Style Guide'}
								ariaLabel="Bikini Style Guide"
								icon={<ArrowSquareOut className="text-black" size={18} weight="light" /> }
								iconGap="gap-2"
								to="/bikini-style-guide"
								underline
							/>
							for the perfect cut and coverage
						</div>
					</div>

					<div className="flex-1 space-y-2">
						<p className="text-lg text-[#3D3D3D] font-semibold">RETURN POLICY</p>
						<div>
							We offer FREE returns for store credit 30 days from date of receipt. Items must be unworn, unwashed, undamaged and not marked as FINAL SALE
						</div>
						<a className="inline-flex gap-1 items-center" href="https://black-bough-swim.reamaze.com/kb/returns" target="_blank" aria-label="Return Policy">
							<span className="text-black underline underline-offset-4">Return Policy</span>
							<ArrowSquareOut className="ml-1" size={18} weight="light" />
						</a>
						{/* <LinkButton 
							className={'text-black'}
							label={'Return Policy'}
							ariaLabel="Return Policy"
							icon={<ArrowSquareOut className="text-black" size={18} weight="light" /> }
							iconGap="gap-2"
							to="/"
							underline
						/> */}
					</div>
				</div>

                <section className="grid grid-cols-1 w-full gap-8 mt-10 py-6">
                    <div className="w-full space-y-4">
						{activeCategory === "swim" ? (
							<SwimSection 
								dropDownContainerStyle="inline-flex gap-4" 
								howToMeasureContainerClassName="w-full flex flex-col lg:flex-row justify-between gap-4 !space-y-0"
								howToMeasureClassName="how-to-measure-item lg:items-start" 
							/>
						) : activeCategory === "women" ? (
							<WomensApparel dropDownContainerStyle="inline-flex gap-4" />
						) : activeCategory === "men" ? (
							<MensApparel dropDownContainerStyle="inline-flex gap-4" />
						) : (
							""
						)}
                    </div>
                </section>
                
				<SuitYourselfSection className="hidden md:block !mt-20" noPaddings />
            </section>
        </Layout>
	)
}

export default BlackboughSizeGuide
